import React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { connect } from 'react-redux';
import { Input, Select, FallbackImage, Render, Button, Table, Pagination, Modal, DatePicker, Viewer, Tooltip } from 'components';
import { RootState } from 'reducers';
import { Globals, Constants } from 'utils';
import { VehicleService } from 'services';
import moment from 'moment';
import { UserIcon, ViewIcon } from 'assets/icons';

interface Props extends RootState, RouteComponentProps {
	dispatch: any;
	item: any;
}

class ModalViewFiles extends React.Component<Props> {

	state = {
		visible: false,
		file: null,
		vehicle: null
	}

	componentDidMount() {
		this.load();
	}

	load = async (withoutLoading = false) => {
		const res: any = await VehicleService.view({
			vehicle_id: this.props.item?.id
		});
		this.setState({
			vehicle: res.vehicle
		});
	}

	viewFile = (e: any, file: string) => {
		e.preventDefault();
		this.setState({
			file,
			visible: true
		});
	}

	render() {
		const { visible } = this.state;
		const vehicle: any = this.state.vehicle;

		const FILES = [
			{
				name: 'Certificado de Registro de vehículo',
				file: Constants.VEHICLE_FILES.VEHICLE_CARD
			},
			{
				name: 'Título de compra venta',
				file: Constants.VEHICLE_FILES.PURCHASE_TITLE
			},
			{
				name: 'Placa Vehícular',
				file: Constants.VEHICLE_FILES.PLATE
			},
			{
				name: 'Poliza de Seguro',
				file: Constants.VEHICLE_FILES.INSURANCE_POLICY
			},
			{
				name: 'Carnet de Circulación',
				file: Constants.VEHICLE_FILES.VEHICLE_CARD
			},
			{
				name: 'ROTC',
				file: Constants.VEHICLE_FILES.ROTC
			},
			{
				name: 'INSOPESCA',
				file: Constants.VEHICLE_FILES.INSOPESCA
			},
			{
				name: 'RACDA',
				file: Constants.VEHICLE_FILES.RACDA
			},
			{
				name: 'PRESQUIMC',
				file: Constants.VEHICLE_FILES.RESQUIMC
			},
			{
				name: 'Registro Sanitario',
				file: Constants.VEHICLE_FILES.HEALTH_REGISTRATION
			}			
		];

		return (
			<div id="modal-view-vehicle-files">
				<Viewer
			      visible={ visible }
			      onClose={ () => this.setState({ visible: false }) }
			      images={ [{ src: this.state.file }] }
			    />

				<div className="row">
					{
						FILES.map((file: any) => {
							const _file = vehicle?.files?.find((i: any) => i.type == file?.file)?.file;

							if (_file)
								return (
									<div className="col-md-6" style={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
										<div className={ `photo-wrapper-file document-photo ${ _file?.endsWith('.pdf') ? 'pdf' : '' }` }>
											{
												vehicle != null && (
													<a href="#" onClick={ (e: any) => this.viewFile(e,Constants.BASE_STORAGE + _file) }>
														<FallbackImage
															src={ Constants.BASE_STORAGE + _file }
															placeholder={UserIcon}
															className="fb-img"
															placeholderClassName="fb-img-placeholder"
														/>
													</a>
												)
											}
										</div>
										<p className="card-foot">
											{ file.name }
											{
												_file?.endsWith('.pdf') && (
													<Tooltip title="Ver">
														<a href={ Constants.BASE_STORAGE + _file } target="_blank">
															<img src={ ViewIcon } className="view-icon" />
														</a>
													</Tooltip>
												)
											}
										</p>
									</div>
								)
						})
					}					
				</div>
			</div>
		)
	}
}

export default connect((state: RootState) => {
	return {
		user: state.user
	}
})(ModalViewFiles);